var _rect, _circle, _rect2, _circle2, _rect3, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTuningControls = function SvgTuningControls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4.25,
    width: 16,
    height: 1.5,
    rx: 0.75,
    fill: "#050400"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 5,
    r: 2.25,
    fill: "#050400"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9.25,
    width: 16,
    height: 1.5,
    rx: 0.75,
    fill: "#050400"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 10,
    r: 2.25,
    fill: "#050400"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 14.25,
    width: 16,
    height: 1.5,
    rx: 0.75,
    fill: "#050400"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 15,
    r: 2.25,
    fill: "#050400"
  })));
};
export default SvgTuningControls;